import LocatorAlerts from './attributes/LocatorAlerts';
import LocatorAlertsDetailRenderer from './detail/LocatorAlertsDetailRenderer';
import LocatorAlertsEqualsComparator from './filters/LocatorAlertsEqualsComparator';
import LocatorAlertsEqualsComparatorEditor from './filters/LocatorAlertsEqualsComparatorEditor';
import LocatorAlertsEqualsComparatorFilterConverter from './filters/LocatorAlertsEqualsComparatorFilterConverter';
import LocatorAlertsNotEqualsComparator from './filters/LocatorAlertsNotEqualsComparator';
import LocatorAlertsNotEqualsComparatorEditor from './filters/LocatorAlertsNotEqualsComparatorEditor';
import LocatorAlertsNotEqualsComparatorFilterConverter from './filters/LocatorAlertsNotEqualsComparatorFilterConverter';
import LocatorAlertsCellRenderer from './table/LocatorAlertsCellRenderer';
export default {
  install(molten) {
    molten.addPlugin('Attribute', LocatorAlerts);
    molten.addPlugin('AttributeCellRenderer', LocatorAlertsCellRenderer);
    molten.addPlugin('AttributeValueRenderer', LocatorAlertsDetailRenderer);
    molten.addPlugin('AttributeConditionComparator', LocatorAlertsEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: LocatorAlertsEqualsComparator.TYPE,
      editor: LocatorAlertsEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', LocatorAlertsEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', LocatorAlertsNotEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: LocatorAlertsNotEqualsComparator.TYPE,
      editor: LocatorAlertsNotEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', LocatorAlertsNotEqualsComparatorFilterConverter);
  }
};